import React from "react";
import { UserAvatar } from "@ui/UserAvatar";
import { getFullName, Profile } from "@clockwise/web-commons/src/util/profile.util";
import { ConfirmationType } from "./scheduling-confirmation";

export interface TitleProps {
  owner: Profile;
  variant: ConfirmationType;
  completed: boolean; // true when successfully booked, cancelled, or rescheduled.
  reasonForChange?: string | null;
}

const PAST_PARTICIPLE: { [T in ConfirmationType]: string } = {
  Book: "booked",
  Cancel: "cancelled",
  Reschedule: "rescheduled",
};

const REASON_HEADER: { [T in ConfirmationType]: string } = {
  Book: "Reason for booking",
  Cancel: "Reason for cancellation",
  Reschedule: "Reason for reschedule",
};

export const ConfirmationTitle = ({ owner, variant, completed, reasonForChange }: TitleProps) => {
  const name = getFullName(owner);
  const showReason = !!reasonForChange && ["Cancel", "Reschedule"].includes(variant);
  return (
    <div>
      <div className="cw-flex cw-items-center cw-gap-4">
        <UserAvatar profile={owner} size="large" cw-id="booking-avatar" />
        <div cw-id="booking-confirmation-message">
          {completed ? (
            <h1 className="cw-font-brand cw-font-bold cw-text-24 cw-leading-tight cw-text-dusk-darker">
              Your meeting with
              <br />
              {name} is {PAST_PARTICIPLE[variant]}
              {variant === ConfirmationType.Book ? "!" : ""}
            </h1>
          ) : (
            <h1 className="cw-font-brand cw-font-bold cw-text-24 cw-leading-tight cw-text-dusk-darker">
              {variant} meeting
              <br />
              with {name}
            </h1>
          )}
        </div>
      </div>
      {showReason && (
        <div
          className={`cw-p-1 cw-pl-2 cw-mb-1 cw-rounded cw-text-slate-darker cw-font-body ${
            variant === "Cancel" ? "cw-bg-yellow-100" : "cw-bg-gray-100"
          }`}
        >
          <p className="cw-font-bold cw-m-2" cw-id="cancel-reschedule-header">
            {REASON_HEADER[variant]}
          </p>
          <p className="cw-m-2" cw-id="cancel-reschedule-reason">
            {reasonForChange}
          </p>
        </div>
      )}
    </div>
  );
};
